import React, { useEffect } from "react";
import { TextareaType } from "../../static/types/commonTypes/textAreaType";
import { ObjectSchema } from 'yup'
import useValidation from "../../hooks/useValidation";

interface TextAreaProps{
    text: TextareaType,
    label: string,
    checked: boolean,
    required: boolean,
    validationSchema: ObjectSchema<TextareaType>,
    updateText: React.Dispatch<React.SetStateAction<TextareaType>>,
    updateValidity: React.Dispatch<React.SetStateAction<boolean>>
}

export default function TextArea({
    text,
    label,
    checked,
    required,
    validationSchema,
    updateText,
    updateValidity
}: TextAreaProps ){

    const { errors, isValid } = useValidation( text, validationSchema )

    useEffect(() => {
        updateValidity( isValid )
    }, [ isValid, updateValidity ])

    return(
        <div className="mb-3 row position-relative">
            <label htmlFor = { label } className="col-sm-2 col-form-label">
                { label } { required && <strong className="text-danger">*</strong> }
            </label>
            <div className="col-sm-4">
                <textarea
                    className = {`form-control ${( checked && errors.value ) ? 'is-invalid': '' }`}
                    id = { label }
                    aria-invalid = {!!(checked && errors.socialObject)}
                    value = { text.value || ""}
                    onChange = {( e ) => updateText({ value: e.target.value })}
                />
                {
                    checked && errors.value &&
                    <div className="invalid-feedback"> { errors.value } </div>
                }
            </div>
        </div>
    )
}